export default __webpack_public_path__ + "static/hero-bg-1x-3ec66f6cb0fa2d9b0e000fe7af39115f.jpg";